import { FetchData } from '../../cloneme-classes';

export class EmailVerification {
  public async init(): Promise<void> {
    await this.setupVerificationEmail();
  }

  public async setupVerificationEmail(): Promise<void> {
    const emailElement = document.querySelector('[data-ms-member="email"]');
    if (emailElement) {
      const email = localStorage.getItem('email') || '';
      emailElement.textContent = email;
    }

    const emailConfirmationButton = document.querySelector(
      '[data-ms-action="send-verification-email"]'
    );
    if (emailConfirmationButton) {
      emailConfirmationButton.addEventListener('click', function (event) {
        event.preventDefault();
        FetchData.sendConfirmationEmail()
          .then((result: any) => console.log(result))
          .catch((error: any) => console.error(error));
      });
    }
  }
}
